import { styled, css } from "@pigment-css/react";
import { clsx } from "clsx";

const ChipContainer = styled("span")(({ theme }) => ({
  fontFamily: theme.managementView.font.familySecondary,
  fontWeight: theme.managementView.font.weight[500],
  letterSpacing: theme.managementView.font.letterSpacing.tight,
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
  borderRadius: theme.managementView.radius[24],
  flexShrink: 0,
  whiteSpace: "nowrap",
}));

// Size styles
const sizeSmallStyles = css(({ theme }) => ({
  padding: `${theme.managementView.spacing[2]} ${theme.managementView.spacing[6]}`,
  fontSize: theme.managementView.font.size[13],
  fontWeight: theme.managementView.font.weight[600],
}));

const sizeLargeStyles = css(({ theme }) => ({
  padding: `${theme.managementView.spacing[6]} ${theme.managementView.spacing[12]}`,
  fontSize: theme.managementView.font.size[14],
}));

// Color styles
const colorDefaultStyles = css(({ theme }) => ({
  backgroundColor: theme.managementView.colors.neutral[4],
  color: theme.managementView.colors.neutral[56],
}));

const colorSuccessStyles = css(({ theme }) => ({
  backgroundColor: theme.managementView.colors.success[4],
  color: theme.managementView.colors.success[100],
}));

const colorErrorStyles = css(({ theme }) => ({
  backgroundColor: theme.managementView.colors.error[4],
  color: theme.managementView.colors.error[100],
}));

export interface ChipProps extends React.HTMLAttributes<HTMLSpanElement> {
  children: React.ReactNode;
  size?: "small" | "large";
  color?: "default" | "success" | "error";
}

export const Chip = ({ children, size = "large", color = "default", className, ...props }: ChipProps) => {
  return (
    <ChipContainer
      className={clsx(
        size === "small" && sizeSmallStyles,
        size === "large" && sizeLargeStyles,
        color === "default" && colorDefaultStyles,
        color === "success" && colorSuccessStyles,
        color === "error" && colorErrorStyles,
        className,
      )}
      {...props}
    >
      {children}
    </ChipContainer>
  );
};
